import { render, staticRenderFns } from "./consumablePurchaseMine.vue?vue&type=template&id=530e6ea3&scoped=true"
import script from "./consumablePurchaseMine.vue?vue&type=script&lang=js"
export * from "./consumablePurchaseMine.vue?vue&type=script&lang=js"
import style0 from "./consumablePurchaseMine.vue?vue&type=style&index=0&id=530e6ea3&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "530e6ea3",
  null
  
)

export default component.exports